import styled from 'styled-components'

export const CountryLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
